<!-- Module Selector with Popover + Command -->
<div class="module-selector-container">
  <!-- Popover Container -->
  <brn-popover
    #popover
    sideOffset="5"
  >
    <!-- Trigger Button -->
    <button
      class="ks-select-trigger"
      [disabled]="disabled() || isLoading()"
      brnPopoverTrigger
    >
      <span class="truncate">
        @if (isLoading()) {
          <span class="flex items-center gap-2">
            <div
              class="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin"
            ></div>
            Lädt...
          </span>
        } @else {
          {{ getSelectedModuleDisplay() }}
        }
      </span>
      <ng-icon name="lucideChevronDown" class="w-4 h-4"></ng-icon>
    </button>

    <!-- Command Content -->
    <div
      hlmPopoverContent
      class="ks-menu-panel w-full min-w-[400px] p-0"
      *brnPopoverContent="let ctx"
    >
      <hlm-command>
        <!-- Search -->
        <hlm-command-search>
          <ng-icon
            hlm
            name="lucideSearch"
            class="shrink-0 opacity-50"
          ></ng-icon>
          <input
            type="text"
            hlm-command-search-input
            placeholder="Modul suchen"
          />
        </hlm-command-search>

        <hlm-command-list>
          <!-- Error State -->
          @if (error()) {
            <p class="px-3 py-3 text-xs leading-normal text-destructive">{{ error() }}</p>
          }

          <!-- Modules Section -->
          @if (!error()) {
            @if (modules() && modules().length > 0) {
              <!-- Modules Group -->
              <hlm-command-group>
                <hlm-command-group-label
                  >Verfügbare Module ({{
                    modules().length
                  }})</hlm-command-group-label
                >

                @for (module of modules(); track module.id) {
                  <button
                    hlm-command-item
                    [value]="getModuleSearchValue(module)"
                    [style.background-color]="
                      selectedModuleId() === module.id ? null : 'transparent'
                    "
                    [class.bg-accent]="selectedModuleId() === module.id"
                    (click)="selectModule(module)"
                  >
                    <ng-icon hlm name="lucideSun" hlmCommandIcon></ng-icon>
                    <div class="flex-1 text-left">
                      <p class="text-sm font-normal truncate">
                        {{ module.name }}
                      </p>
                      <p class="text-xs text-muted-foreground truncate">
                        {{ module.power }} kWp •
                        {{ getModuleAreaDisplay(module) }} m²
                      </p>
                    </div>
                    @if (selectedModuleId() === module.id) {
                      <ng-icon
                        hlm
                        name="lucideCheck"
                        class="w-4 h-4 text-primary flex-shrink-0"
                      ></ng-icon>
                    }
                  </button>
                }
              </hlm-command-group>
            } @else if (!isLoading()) {
              <!-- Empty state -->
              <div *brnCommandEmpty hlmCommandEmpty>
                Keine Module vorhanden
              </div>
            }
          }
        </hlm-command-list>
      </hlm-command>
    </div>
  </brn-popover>
</div>
